<template>
  <header-block></header-block>
  <div class="page-container">
    <div class="inner-wide home-grid">
      <div class="home-main">
        <div>
          <h1 class="greeting">
            {{ $t(greetingKey) }}{{ userName ? ", " + userName : "" }} 👋
          </h1>
          <div class="hint-text">
            {{ $t("editor.storefront_overview") }}
          </div>
        </div>

        <div class="stat-grid">
          <router-link to="/editor" class="stat-card">
            <span class="stat-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 3v4a1 1 0 0 0 1 1h4" />
                <path
                  d="M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z"
                />
                <path
                  d="M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
                />
              </svg>
            </span>
            <span class="stat-label">{{ $t("editor.pages") }}</span>
            <span class="stat-count">{{ page_count ?? "–" }}</span>
            <span class="stat-hint">{{ $t("editor.manage_landing") }}</span>
          </router-link>
          <router-link to="/menu" class="stat-card">
            <span class="stat-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 4h6v6h-6z" />
                <path d="M14 4h6v6h-6z" />
                <path d="M4 14h6v6h-6z" />
                <path d="M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
              </svg>
            </span>
            <span class="stat-label">{{ $t("editor.menus") }}</span>
            <span class="stat-count">{{ menu_count ?? "–" }}</span>
            <span class="stat-hint">{{ $t("editor.navigation") }}</span>
          </router-link>
          <router-link to="/translator" class="stat-card">
            <span class="stat-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 5h7" />
                <path d="M9 3v2c0 4.418 -2.239 8 -5 8" />
                <path d="M5 9c0 2.144 2.952 3.908 6.7 4" />
                <path d="M12 20l4 -9l4 9" />
                <path d="M19.1 18h-6.2" />
              </svg>
            </span>
            <span class="stat-label">{{ $t("editor.translations") }}</span>
            <span class="stat-count">&nbsp;</span>
            <span class="stat-hint">{{ $t("editor.copy_languages") }}</span>
          </router-link>
        </div>

        <TemplateSelector v-bind:sites="webshops" :templates="templates" />
      </div>
      <div class="home-side">
        <div class="white-box">
          <div class="card-head mb-2">
            <h1>{{ $t("editor.recent_activities") }}</h1>
          </div>
          <div class="timeline">
            <div
              v-for="item in recentActivities"
              :key="item.id"
              class="timeline-item"
            >
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-name">
                  {{ item.first_name }} {{ item.last_name }}
                </div>
                <div class="timeline-type">{{ item.name }}</div>
                <small class="timeline-date">{{ item.date }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderBlock from "../components/header";
import TemplateSelector from "../components/TemplateSelector.vue";
import http from "../modules/http";
import store from "../store";
export default {
  name: "HomePage",
  components: { TemplateSelector, HeaderBlock },
  data() {
    return {
      webshops: [],
      templates: [],
      recentActivities: [],
      menu_count: null,
      page_count: null,
    };
  },
  computed: {
    greetingKey() {
      const hour = new Date().getHours();
      let text = "editor.good_morning";
      if (hour >= 18 || hour < 4) {
        text = "editor.good_evening";
      } else if (hour >= 12) {
        text = "editor.good_afternoon";
      }
      return text;
    },
    userName() {
      return store.state.user?.first_name;
    },
  },
  mounted() {
    http.fetch(`/themes`).then((data) => {
      this.webshops = data.webshops;
      this.templates = data.data;
      this.page_count = data.page_count;
      this.menu_count = data.menu_count;
      this.recentActivities = data.history;
    });
  },
};
</script>
<style scoped>
.home-grid {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 18px;
  align-items: start;
}
@media (max-width: 980px) {
  .home-grid {
    grid-template-columns: 1fr;
  }
}
.home-main {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
}
.greeting {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 4px 0;
}
.stat-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}
@media (max-width: 767px) {
  .stat-grid {
    grid-template-columns: 1fr;
  }
}
</style>
